module.exports = __webpack_public_path__ + "img/centrifuge-A-shadow.cab89cdb.png";